import { ItemsPDFWrapper } from '../../../../../features/ui'
import { CodedDataType } from '../../../../../tables'
import { DeliveryNotePDFPage } from './deliveryNotePDFPage'
import { Item } from '../../../../operations'
import { Delivery, DeliveryOrder } from '../../../state/types'

type Props = {
    id: string
    delivery: Delivery
    deliveryOrder?: DeliveryOrder
    previewMode?: boolean
}

export const DeliveryNotePDF = (props: Props) => {
    const { id, delivery, deliveryOrder, previewMode } = props

    const renderPDFPage = (
        pageIndex: number,
        dataType: CodedDataType,
        _: Item[],
        pagesAmount: number
    ) => (
        <DeliveryNotePDFPage
            pageIndex={pageIndex}
            delivery={dataType as Delivery}
            deliveryOrder={deliveryOrder}
            pagesAmount={pagesAmount}
        />
    )

    return (
        <ItemsPDFWrapper
            id={id}
            dataType={delivery as CodedDataType}
            items={[]}
            previewMode={previewMode}
            renderPDFPage={renderPDFPage}
        />
    )
}
